// src/components/ValueRibbon.tsx
import React from "react";
import { Box, Container, Paper, Typography, Grid } from "@mui/material";
import BoltIcon from "@mui/icons-material/Bolt"; // Performance
import VerifiedIcon from "@mui/icons-material/Verified"; // Integrity
import LightbulbIcon from "@mui/icons-material/Lightbulb"; // Initiative
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd"; // Ownership
import GroupsIcon from "@mui/icons-material/Groups"; // Teamwork

const coreValues = [
  { label: "Performance", icon: <BoltIcon fontSize="large" color="primary" /> },
  { label: "Integrity", icon: <VerifiedIcon fontSize="large" color="primary" /> },
  { label: "Initiative", icon: <LightbulbIcon fontSize="large" color="primary" /> },
  { label: "Ownership", icon: <AssignmentIndIcon fontSize="large" color="primary" /> },
  { label: "Teamwork", icon: <GroupsIcon fontSize="large" color="primary" /> },
];

export const ValueRibbon = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: -6, position: "relative", zIndex: 10 }}>
      <Grid container spacing={2} justifyContent="center">
        {coreValues.map((value) => (
          // xs={6} sm={4} md={2.4}
          <Grid sx={{ xs: 6, sm: 4, md: "2.4" }} key={value.label}>
            <Paper
              elevation={6}
              sx={{
                p: 3,
                textAlign: "center",
                borderRadius: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                transition: "0.3s",
                "&:hover": { transform: "scale(1.05)" },
              }}
            >
              <Box sx={{ mb: 1 }}>{value.icon}</Box>
              <Typography variant="subtitle2" fontWeight="700" color="text.primary">
                {value.label}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
